import { Container } from '..';
import styles from './FoodOptimizationSection.module.css';

const cx = (...args: Array<string | false | undefined | null>) =>
  args.filter(Boolean).join(' ');

export const FoodOptimizationSection = ({
  className,
  data,
}: {
  className?: string;
  data: any;
}) => {
  const emptyDiv = (
    <div style={{ padding: '50px', background: 'transparent' }}></div>
  );

  if (!data.optimisations) return emptyDiv;

  const optimisations: any[] = Array.isArray(data.optimisations)
    ? data.optimisations
    : JSON.parse(data.optimisations);

  if (!Array.isArray(optimisations) || !(optimisations.length > 0))
    return emptyDiv;

  function extractTitleAndDescription(input: string) {
    input = input.replaceAll(':', '');
    const [, title, description] = input.replaceAll(':', '').split('**');
    return {
      title: title ?? null,
      description: description ?? null,
    };
  }

  return (
    <section className={cx(styles.root, className)}>
      <Container>
        <div className={styles.content}>
          {data.optimise_title ? <h3>{data.optimise_title}</h3> : null}

          <div className={styles.optimizationContent}>
            {optimisations?.map((e: string, i: number) => {
              const { title, description } = extractTitleAndDescription(e);
              if (!title && !description) return null;
              return (
                <div key={i} className={styles.optimizationElement}>
                  {title ? <h4>{title}</h4> : null}
                  {description ? <p>{description}</p> : null}
                </div>
              );
            })}
          </div>
        </div>
      </Container>
    </section>
  );
};
